// extracted by mini-css-extract-plugin
export var attribution = "_da-4";
export var authorName = "_da-5";
export var quote = "_da-3";
export var testimonial = "_da-2";
export var trustedBy = "_da-0";
export var trustedByLabel = "_da-1";